import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/location_new/san-francisco/san_banner.webp";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner hosuton_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>App Developers in San Francisco</h1>
              <p className="main_para">
                Dominate the tech-industry of the transforming San Francisco
                city and increase your chance of maximizing the business reach.
                We can help you build a purpose-built mobile application that
                fulfills the user expectations, resulting in high ROI. Our
                mobile app development company in San Francisco to interactively
                design your app and build rich-featured functionality that
                creates a difference in the market.
              </p>
              <Link
                to="/app-cost-calculator"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
